angular
  .module("myApp")
  .controller(
    "HomeController",
    function HomeController(
      $scope,
      $state,
      $window,
      $rootScope,
      ngDialog,
      authentication,
      Notification,
      $http
    ) {
      this.print = () => {
        if ($rootScope.allowPrint) {
          $window.print()
        }
      }

      this.confirmApstrade = () => {
        $http({ method: "POST", url: "/data/confirm_apstrade", data: { id: 0 } })
          .then(() => {
            authentication.refresh()
          })
          .catch($scope.failing)
      }

      this.confirmKonfidenc = () => {
        $http({ method: "POST", url: "/data/confirm_konfidenc", data: { id: 0 } })
          .then(() => {
            authentication.refresh()
          })
          .catch($scope.failing)
      }

      this.infoDialog = (templateUrl) => {
        ngDialog
          .openConfirm({
            template: templateUrl,
            className: "ngdialog-text-left ngdialog-theme-default",
          })
          .then(() => {})
      }

      this.goTo = (goToState) => {
        $state.go(
          goToState,
          {
            context: $rootScope.u.context,
          },
          {
            reload: true,
          }
        )
      }

      this.state = $state

      const org_contexts = {
        organization_iesniedzejs: true,
        organization_postdoc: true,
        organization_darbinieks: true,
      }
      const all_non_expert = {
        anonymous: true,
        manager: true,
        expert: false,
        organization_iesniedzejs: true,
        organization_postdoc: true,
        organization_darbinieks: true,
      }

      this.menu = [
        {
          sref: "app.org-dashboard",
          contexts: org_contexts,
          icon: "fa-edit text-lzp",
          title: "Pārskats",
          description: "Darbs ar apstiprinātajiem pieteikumiem",
        },
        {
          sref: "app.expert-application.list",
          context: "expert",
          group: "project_application",
          icon: "fa-edit text-lzp",
          title: "Project applications",
          description: "Applications assigned to you",
        },
        {
          sref: "app.application.list",
          contexts: org_contexts,
          group: "project_application",
          icon: "fa-edit text-lzp",
          title: "Pētniecības pieteikumi",
          description: "Jūsu iesniegtie pieteikumi",
          subs: {
            "app.application.list": {
              icon: "fa-circle-o",
              title: "Visi pieteikumi",
            },
            "app.application.list-melnraksti": {
              icon: "fa-circle-o",
              title: "Melnraksti",
            },
            "app.application.list-iesniegtie": {
              icon: "fa-circle-o",
              title: "Iesniegtie",
            },
          },
        },
        {
          sref: "app.maksajumi.list",
          context: "manager",
          group: "maksajumi",
          icon: "fa-money",
          title: "Maksājumu pieteikumi",
          description: "Iesniegtie un apstiprinātie maksājumu pieteikumi",
          subs: {
            "app.maksajumi.list": {
              icon: "fa-circle-o",
              title: "Iesniegtie",
            },
            "app.maksajumi.list-all": {
              icon: "fa-circle-o",
              title: "Visi pieteikumi",
            },
          },
        },
        {
          sref: "app.submissions.nlist",
          context: "manager",
          group: "submissions",
          icon: "fa-edit",
          title: "Pētniecības pieteikumi",
          description: "Iesniegtie un apstiprinātie pētniecības pieteikumi",
          subs: {
            "app.submissions.nlist": {
              icon: "fa-circle-o",
              title: "Pētniecības pieteikumi",
            },
            "app.submissions.list": {
              icon: "fa-circle-o",
              title: "Vecais saraksts",
            },
            "app.submissions.list-lzp": {
              icon: "fa-circle-o",
              title: "LZP ievadītie",
            },
            "app.submissions.list-all": {
              icon: "fa-circle-o",
              title: "Visi pieteikumi",
            },
          },
        },
        {
          sref: "app.calendar",
          context: "manager",
          group: "calendar",
          icon: "fa-calendar",
          title: "Kalendārs",
          description: "Plānoto un veikto pārbaužu kalendārs",
        },
        {
          sref: "app.organization.list",
          context: "manager",
          group: "organization",
          icon: "fa-university",
          title: "Organizācijas",
          description: "Sistēmā reģistrētās organizācijas un to lietotāji",
        },
        {
          sref: "app.reports.a10",
          context: "manager",
          group: "reports",
          icon: "fa-users",
          title: "Atskaites",
          description: "Pieteikumu atskaites",
          subs: {
            "app.reports.a10": {
              icon: "fa-circle-o",
              title: "Iznākuma rādītāji",
            },
            "app.reports.a20": {
              icon: "fa-circle-o",
              title: "Uzraudzības rādītāji",
            },
            "app.reports.a30": {
              icon: "fa-circle-o",
              title: "Finansējums",
            },
            "app.reports.mp_finansejums": {
              icon: "fa-circle-o",
              title: "MP finansējums",
            },
          },
        },
        {
          sref: "app.user.list",
          context: "manager",
          group: "user",
          icon: "fa-users",
          title: "Lietotāji",
          description: "Pilns sistēmas lietotāju saraksts",
          subs: {
            "app.user.list": {
              icon: "fa-circle-o",
              title: "Visi lietotāji",
            },
            "app.user.list-lzp": {
              icon: "fa-circle-o",
              title: "LZP darbinieki",
            },
            "app.user.list-experts": {
              icon: "fa-circle-o",
              title: "Ārējie eksperti",
            },
            "app.user.list-org": {
              icon: "fa-circle-o",
              title: "Organizāciju lietotāji",
            },
          },
        },
        {
          sref: "app.manager.settings.submission",
          context: "manager",
          group: "submission-setup",
          icon: "fa-gear",
          title: "Iestatījumi",
          description: "Atļaut vai slēgt pieteikšanos",
          subs: {
            "app.manager.settings.submission": {
              icon: "fa-circle-o",
              title: "Pieteikumu kārtas",
            },
            "app.manager.settings.email": {
              icon: "fa-circle-o",
              title: "Ziņojumi",
            },
            "app.manager.settings.nzdis-export": {
              icon: "fa-circle-o",
              title: "NZDIS eksports",
            },
            "app.manager.settings.texts": {
              icon: "fa-circle-o",
              title: "Tekstiņi",
            },
          },
        },
        {
          sref: "app.manager.sent-emails",
          context: "manager",
          group: "sent-emails",
          icon: "fa-envelope",
          title: "Izsūtītās vēstules",
          description: "Saraksts ar sistēmas izsūtītajām vēstulēm",
        },
        {
          sref: "app.manager.templates.list",
          context: "manager",
          group: "templates",
          icon: "fa-file-word-o",
          title: "Šablonu faili",
          description: "Līgumu, vēstuļu, u.c. šabloni",
        },
        {
          sref: "app.files",
          contexts: all_non_expert,
          group: "files",
          icon: "fa-question-circle text-lzp",
          title: "Publiskie faili",
          description: "Lietotājiem noderīgie faili",
        },
        {
          sref: "app.files",
          context: "expert",
          group: "files",
          icon: "fa-question-circle text-lzp",
          title: "Public documents",
          description: "Publicly accessible system documents",
        },
        {
          sref: "app.manager.files.list",
          context: "manager",
          group: "files.manager",
          icon: "fa-question-circle",
          title: "Publisko failu ielāde",
          description: "Lietotājiem noderīgo failu uzturēšana",
        },
        {
          sref: "app.about",
          context: "expert",
          hidden_index: true,
          group: "about",
          icon: "fa-question-circle text-lzp",
          title: "About the system",
        },
        {
          sref: "app.about",
          contexts: all_non_expert,
          hidden_index: true,
          group: "about",
          icon: "fa-question-circle text-lzp",
          title: "Par sistēmu",
        },
      ]
      if ($state.current.name === "app.sso-error") {
        Notification.error("Neizdevās autentificēt NZDIS lietotāju, notika servera kļūda.")
      }
      if ($state.current.name === "app.sso-nouser") {
        Notification.error("Pie mums nav reģistrēts atbilstošs lietotājs.")
      }
    }
  )

  .controller("DashboardController", function DashboardController($scope, $state, uuiData, MpJauns) {
    this.nextPage = () => {}

    $scope.ready = false

    const key = "dashboard.page"

    this.setPage = (p) => {
      if ($scope.pages[p]) {
        $scope.page = p
        $scope.pieteikumi = $scope.pages[p]
        localStorage.setItem(key, p)
      } else {
        $scope.page = 0
        $scope.pieteikumi = $scope.pages[0]
      }
    }

    const chunk_array = (arr, max_elts) => {
      return Array.from({ length: Math.ceil(arr.length / max_elts) }, (_, i) =>
        arr.slice(i * max_elts, (i + 1) * max_elts)
      )
    }

    $scope.pieteikumi = uuiData.list("dashboard_apstiprinatie_list", (data) => {
      $scope.pages = chunk_array(data, 10)
      this.setPage(Number.parseInt(localStorage.getItem(key), 10) || 0)
      $scope.ready = true
      return data
    })

    this.rev_statuss = {
      NEAKTUALS: "Neaktuāls maksājuma pieteikums",
      MELNRAKSTS: "Maksājuma pieteikuma melnraksts",
      "MELNRAKSTS-LABOJUMS": "Maksājuma pieteikuma melnraksts, labojums",
      IESNIEGTS: "Iesniegts maksājuma pieteikums",
      IZSKATISANA: "Iesniegts maksājuma pieteikums, izskatīšanā",
      LZP_OK: "Iesniegts maksājuma pieteikums, izskatīšanā",
      IZSKATITS: "Izskatīts maksājuma pieteikums",
      SAMAKSATS: "Samaksāts maksājuma pieteikums",
      "NETIKS-ISTENOTS": "Netiks īstenots",
    }

    this.createMaksajumaPieteikums = (p) => {
      const mp = new MpJauns({ pieteikums_id: p.pieteikums_id, versija_id: p.versija_id })
      mp.$create(() => {
        $state.go("app.mp.edit.open", {
          id: mp.id,
        })
      }, $scope.failing)
    }
  })
